// GET /catalog/products returns one ROW PER (product, tier) pair
// (productRepository.getProductsForSales's LEFT JOIN product_prices has no
// tier filter — see that file's own comment: "One row per product+tier
// pair... callers group by product_id if a nested shape is needed"). This
// is that grouping, done once here rather than re-derived in every
// component that touches catalog search results.
//
// Deliberately does NOT try to guess which tier row is "the" one that
// applies to the request's organization — there is no endpoint reachable
// from this workspace that reports an organization's tier (requests only
// carry organization_id, see backend/src/repositories/requestRepository.js's
// REQUEST_COLUMNS), so every tier row this product has is kept and shown,
// never collapsed to a single assumed-correct one. See this task's final
// report for why that is a real, documented API-surface gap rather than a
// UI oversight.
export function groupProductRowsById(rows) {
  const map = new Map();
  for (const row of rows) {
    if (!map.has(row.id)) {
      map.set(row.id, {
        id: row.id,
        sku: row.sku,
        name: row.name,
        nameAm: row.name_am,
        brand: row.brand,
        model: row.model,
        spec: row.spec,
        unit: row.unit,
        categoryId: row.category_id,
        stockQty: row.stock_qty,
        tiers: [],
      });
    }
    const product = map.get(row.id);
    if (row.tier) {
      product.tiers.push({
        tier: row.tier,
        listPrice: row.list_price,
        floorPrice: row.floor_price,
      });
    }
  }
  return map;
}

export default groupProductRowsById;
